/* eslint-disable no-comments/disallowComments */
import React from 'react';
import { styled } from '@mui/material';

interface RSplitLayoutProps {
    /** Left-column content (narrow, fixed width). */
    sidebar: React.ReactNode;
    /** Right-column content (flexible width). */
    main: React.ReactNode;
    className?: string;
}

export function RSplitLayout({ sidebar, main, className }: RSplitLayoutProps) {
    return (
        <Grid className={className}>
            <div>{sidebar}</div>
            <div>{main}</div>
        </Grid>
    );
}

const Grid = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '380px 1fr',
    gap: 24,
    alignItems: 'start',
    [theme.breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
        gap: 16,
    },
}));
/* eslint-enable no-comments/disallowComments */
